import { PlanningProfile } from './planning-profile';
import { Recipe } from './recipe-model';
import { Nutrition } from './nutrition-model';
import {PlanningMenu} from './planning-menu';

export class ProfileNutrition {
    ShowPlan = false;
    isHidden: boolean;
    isHiddenProfiles: boolean;
    Profile: PlanningProfile;
    Recipes: Recipe[] = [];
    Nutrition: Nutrition = new Nutrition();
    Menu: PlanningMenu[] = [];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/profile-nutrition.ts